import React, { SVGProps } from "react"
import Pause from "./Pause"
import PauseHover from "./PauseHover"

const VideoPauseIcon = (props: SVGProps<SVGSVGElement>) => {
  const [isHovered, setIsHovered] = React.useState(false)
  return (
    <span
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
      onTouchStart={() => setIsHovered(true)}
    >
      {!isHovered ? <Pause {...props} /> : <PauseHover {...props} />}
    </span>
  )
}

export default VideoPauseIcon
